import React from "react";
import TrackVisibility from "react-on-screen";
import Skill from "../Items/Skill";

const skillData = {
  skillContent:
    "With a strong foundation in IT and a passion for DevOps, I have developed expertise in tools and technologies like Linux, Docker, Kubernetes, CI/CD pipelines, and Python scripting. I am driven to continuously learn and apply my skills to create efficient and scalable systems.",
  progressData: [
    {
      id: 1,
      name: "Linux",
      percentage: 70,
    },
    {
      id: 2,
      name: "Docker",
      percentage: 70,
    },
    {
      id: 3,
      name: "Kubernetes",
      percentage: 60,
    },
    {
      id: 4,
      name: "CI/CD Pipelines",
      percentage: 80,
    },
    {
      id: 5,
      name: "Python Scripting",
      percentage: 30,
    },
    {
      id: 6,
      name: "Elasticsearch & Kibana",
      percentage: 80,
    },
    {
      id: 7,
      name: "Grafana & Prometheus",
      percentage: 80,
    },
    {
      id: 8,
      name: "WordPress Administration",
      percentage: 60,
    },
    {
      id: 9,
      name: "HTML & CSS",
      percentage: 30,
    },
    {
      id: 10,
      name: "Git & Version Control",
      percentage: 60,
    },
  ],
};

function Skills() {
  return (
    <>
      <p className="mb-0">{skillData.skillContent}</p>
      <div className="mt-5">
        <div className="row -mt-50">
          {skillData.progressData.map((progress) => (
            <div className="col-md-6 mt-50" key={progress.id}>
              <TrackVisibility once>
                <Skill progress={progress} />
              </TrackVisibility>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Skills;
